import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { booksClient, errMsg } from './api';

const BooksForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await booksClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050b12] text-slate-100" data-testid="books-forgot-page">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 left-1/2 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-emerald-500/20 blur-[120px]" />
      </div>
      <div className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6">
        <Link to="/books" className="mb-8 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 font-bold text-white">EB</div>
          <div className="text-lg font-semibold">Emerald Books</div>
        </Link>
        <div className="w-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur">
          {sent ? (
            <div data-testid="forgot-success">
              <div className="mb-2 text-2xl font-semibold text-white">Check your inbox</div>
              <div className="mb-6 text-sm text-slate-400">
                If an account exists for <strong className="text-white">{email}</strong>, we've sent a password reset link. It expires in 1 hour.
              </div>
              <Link to="/books/login" className="text-sm text-emerald-400 hover:text-emerald-300" data-testid="forgot-back-login">
                ← Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="mb-2 text-2xl font-semibold text-white">Reset your password</div>
              <div className="mb-6 text-sm text-slate-400">
                Enter your account email and we'll send you a reset link.
              </div>
              <label className="mb-1 block text-xs text-slate-400">Email</label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mb-4 border-white/10 bg-white/[0.03] text-white"
                data-testid="forgot-email-input"
              />
              <Button
                type="submit"
                disabled={loading}
                className="h-11 w-full rounded-full bg-emerald-500 font-semibold text-white hover:bg-emerald-400"
                data-testid="forgot-submit"
              >
                {loading ? 'Sending…' : 'Send reset link'}
              </Button>
              <div className="mt-4 text-center text-sm text-slate-400">
                Remember your password?{' '}
                <Link to="/books/login" className="text-emerald-400 hover:text-emerald-300">Log in</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default BooksForgotPasswordPage;
